import { formatCHF } from "../../lib/api";

/**
 * 15-month timeline with declining deduction.
 * Renders horizontally scrollable segmented blocks.
 */
export function GroupTimeline({ timeline = [], currentMonth = 1 }) {
  if (!timeline || timeline.length === 0) return null;
  const maxDed = Math.max(...timeline.map((t) => t.deduction));
  return (
    <div className="nv-border bg-white rounded-md overflow-hidden">
      <div className="px-4 md:px-5 py-4 border-b border-[#E2E8E4] flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="nv-label">Laufzeit</div>
          <div className="font-heading text-lg md:text-xl font-semibold text-[#0F4C3A] mt-1">
            {timeline.length}-Monate-Plan
          </div>
        </div>
        <div className="text-xs text-[#94A3B8]">Aktueller Monat: <span className="font-mono-nv text-[#0F4C3A] font-semibold">{currentMonth}</span></div>
      </div>
      <div className="overflow-x-auto">
        <div className="flex min-w-max">
          {timeline.map((m) => {
            const isFoundation = m.month === 1;
            const isCurrent = m.month === currentMonth;
            const heightPct = maxDed > 0 ? Math.max(10, (m.deduction / maxDed) * 100) : 10;
            return (
              <div
                key={m.month}
                className={`relative flex-shrink-0 w-20 md:w-24 border-r border-[#E2E8E4] transition-all ${
                  isCurrent ? "bg-[#FEF3C7]" : ""
                }`}
                data-testid={`timeline-month-${m.month}`}
              >
                <div className="px-2 pt-3 pb-2">
                  <div className="nv-label">Monat</div>
                  <div className="font-mono-nv text-xl md:text-2xl font-semibold text-[#0F4C3A]">{m.month}</div>
                  {isFoundation && (
                    <div className="mt-1 text-[9px] md:text-[10px] font-semibold tracking-wider text-[#D4AF37] uppercase">Foundation</div>
                  )}
                  {isCurrent && !isFoundation && (
                    <div className="mt-1 text-[9px] md:text-[10px] font-semibold tracking-wider text-[#D97706] uppercase">Aktuell</div>
                  )}
                </div>
                <div className="h-16 md:h-20 flex items-end px-2 md:px-3 pb-0">
                  <div
                    className={`w-full rounded-t transition-all ${isFoundation ? "bg-[#D4AF37]" : "bg-[#0F4C3A]"}`}
                    style={{ height: `${heightPct}%` }}
                  />
                </div>
                <div className="border-t border-[#E2E8E4] px-2 py-2">
                  <div className="nv-label text-[9px] md:text-[10px]">Abzug</div>
                  <div className="font-mono-nv text-xs md:text-sm font-semibold text-[#0F4C3A]">CHF {formatCHF(m.deduction)}</div>
                  <div className="nv-label text-[9px] md:text-[10px] mt-2">Auszahlung</div>
                  <div className="font-mono-nv text-xs md:text-sm font-semibold text-[#0F4C3A]">CHF {formatCHF(m.payout)}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
